import { useState, useEffect } from 'react';
import { musikkAPI, MusikkTransponering } from '@/services/api';

interface UseTranspositionsProps {
  musikkId: number | undefined;
}

export const useTranspositions = ({ musikkId }: UseTranspositionsProps) => {
  const [savedTranspositions, setSavedTranspositions] = useState<MusikkTransponering[]>([]);
  const [loading, setLoading] = useState(false);

  const loadTransponeringer = async () => {
    if (!musikkId) return;
    
    try {
      setLoading(true);
      const response = await musikkAPI.getAllTransponeringer(musikkId);
      setSavedTranspositions(response.transponeringer);
    } catch (err) {
      console.error('Kunne ikke laste transponeringer:', err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (musikkId) {
      loadTransponeringer();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [musikkId]);

  return {
    savedTranspositions,
    loading,
    loadTransponeringer,
  };
};

